export const REQUIRED_FILES = {
  mobilePharmacist: ['carePlan'],
  mobileDietitian: ['carePlan'],
  mobileRehabilitation: ['carePlan'],
  mobilePsychologist: ['carePlanWithTransit'],
  homeServices: ['taiwaneseIdFront', 'taiwaneseIdBack'],
  homeDentalCare: ['nhiCard', 'disabilityCertFront', 'disabilityCertBack', 'carePlan'],
  homeNursingCare: ['nhiCard', 'barthelIndex', 'carePlan'],
  homeMedicalCare: ['nhiCard', 'barthelIndex', 'carePlan'],
}
